import { NotifyContext, NotifyAction } from './common/Context';
import Menu from './common/Menu';
import Footer from './common/Footer';
import Router from './common/Router';

function App() {
  const { notification, setNotification } = NotifyAction();
  return (
    <NotifyContext.Provider value={{ state: notification, action: setNotification }}>
      <Menu />
      <Router />
      <Footer />
    </NotifyContext.Provider>
  );
}

export default App;
